import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';

import '../Main.scss';

import {
    Nav,
    NavItem,
} from 'reactstrap';

import { 
    SettingsTab,
    GetSettingTabLabel,
} from './SettingsTypes';

import { PortalTextSettings } from '../../Models/Api/strongbox.financialportal';

type Props = {
    tabs: SettingsTab[];
    settingsText?: PortalTextSettings;
};

export const SettingsNav: React.FC<Props> = (props): React.ReactElement => {
    const location = useLocation();

    return (
        <Nav
            tabs
            className={`portal-tabs`}
        >
            {props.tabs.map((tab, index) => {
                let navItemClass = '';
                let navLinkClass = '';

                if (location && location.pathname === tab.path) {
                    navItemClass = `portal-nav-item-active`;
                    navLinkClass = 'portal-nav-link-active';
                } else {
                    navItemClass = `portal-nav-item-inactive`;
                    navLinkClass = '';
                }
                return (
                    <NavItem
                        id={tab.tabId}
                        key={tab.tabId}
                        className={`portal-nav-item ${navItemClass}`}
                    >
                        <Link
                            className={`portal-nav-link ${navLinkClass}`}
                            id={tab.tabId}
                            to={tab.path}
                        >
                            {GetSettingTabLabel(tab.tabId, props.settingsText)}
                        </Link>
                    </NavItem>
                )
            })}
        </Nav>
    );
}

